import { withInstall } from '@/utils'
import CosDatePicker from './src/cosDatePicker.vue'
export default withInstall(CosDatePicker)
